/**
 * iurop-product-card.js — Product card Laganini
 *
 * - Tallas quick-add (hover desktop): el chip [data-card-size] fija el id de
 *   variante en su form [data-quick-add-form] y lo envia. El AJAX lo hace el
 *   handler global delegado de header.js (submit en [data-quick-add-form]).
 * - Wishlist: [data-wishlist-toggle] persiste handles en localStorage
 *   'laganini:wishlist' y emite 'wishlist:changed' (document) con
 *   { detail: { handle, active, handles } }.
 * - Quick-view: [data-quick-view] abre el modal global (snippet
 *   iurop-quick-view) con el JSON [data-qv-data] de la card.
 * - Preview de colorway: al pasar el raton (o al enfocar) un swatch
 *   [data-card-swatch-src], la card muestra la foto de ese colorway en una
 *   capa propia. El clic sigue navegando: cada colorway es un producto
 *   distinto (custom.color_siblings), no una variante.
 *
 * Todo delegado en document: sobrevive a re-renders del editor y a cards
 * inyectadas (busqueda, related, section rendering).
 */
(function () {
  'use strict';

  var WISHLIST_KEY = 'laganini:wishlist';
  var feedbackTimer = null;

  function showWishlistFeedback(active) {
    var toast = document.querySelector('[data-wishlist-feedback]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'laganini-wishlist-feedback';
      toast.setAttribute('data-wishlist-feedback', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    var labels = document.querySelector('[data-wishlist-added][data-wishlist-removed]');
    if (!labels) return;
    toast.textContent = labels.getAttribute(active ? 'data-wishlist-added' : 'data-wishlist-removed');
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    window.clearTimeout(feedbackTimer);
    feedbackTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 1800);
  }

  // --- Wishlist -----------------------------------------------------------
  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      /* noop */
    }
  }

  function paintWishlistStates(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = readWishlist();
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-wishlist-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toggleWishlist(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    var list = readWishlist();
    var idx = list.indexOf(handle);
    var active = idx === -1;
    if (active) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    writeWishlist(list);
    // Pinta TODAS las instancias de ese handle (card + PDP)
    document.querySelectorAll('[data-wishlist-toggle][data-wishlist-handle="' + handle + '"]').forEach(function (b) {
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.dispatchEvent(
      new CustomEvent('wishlist:changed', { detail: { handle: handle, active: active, handles: list } })
    );
  }

  // --- Preview de colorway -------------------------------------------------
  var previewCard = null;

  function previewLayer(card) {
    var link = card.querySelector('.iurop-product-card__media-link');
    if (!link) return null;
    var img = link.querySelector('.iurop-product-card__image--preview');
    if (!img) {
      img = document.createElement('img');
      img.className = 'iurop-product-card__image iurop-product-card__image--preview';
      img.alt = '';
      img.decoding = 'async';
      img.setAttribute('aria-hidden', 'true');
      link.appendChild(img);
    }
    return img;
  }

  function hidePreview(card) {
    var scope = card || previewCard;
    if (!scope) return;
    var img = scope.querySelector('.iurop-product-card__image--preview');
    if (img) {
      img.setAttribute('data-preview-on', '0');
      img.classList.remove('is-visible');
    }
    if (scope === previewCard) previewCard = null;
  }

  function showPreview(swatch) {
    var src = swatch.getAttribute('data-card-swatch-src');
    var fit = swatch.getAttribute('data-card-swatch-fit');
    var card = swatch.closest('[data-product-card]');
    if (!src || !card) return;
    if (previewCard && previewCard !== card) hidePreview(previewCard);
    var img = previewLayer(card);
    if (!img) return;
    img.classList.toggle('iurop-product-card__image--contain', fit === 'contain');
    previewCard = card;
    img.setAttribute('data-preview-on', '1');
    if (img.getAttribute('src') !== src) {
      img.classList.remove('is-visible');
      img.onload = function () {
        // El puntero pudo salir mientras descargaba: solo aparece si sigue pedida
        if (img.getAttribute('data-preview-on') === '1') img.classList.add('is-visible');
      };
      img.setAttribute('src', src);
    } else if (img.complete) {
      img.classList.add('is-visible');
    }
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var swatch = e.target.closest('[data-card-swatch-src]');
    if (swatch) {
      showPreview(swatch);
    } else if (previewCard) {
      hidePreview(previewCard);
    }
  });

  document.addEventListener('focusin', function (e) {
    if (!e.target.closest) return;
    var swatch = e.target.closest('[data-card-swatch-src]');
    if (swatch) {
      showPreview(swatch);
    } else if (previewCard) {
      hidePreview(previewCard);
    }
  });

  // --- Delegacion global ---------------------------------------------------
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var wish = e.target.closest('[data-wishlist-toggle]');
    if (wish) {
      e.preventDefault();
      toggleWishlist(wish);
      return;
    }

    var size = e.target.closest('[data-card-size]');
    if (size) {
      e.preventDefault();
      var form = size.closest('[data-quick-add-form]');
      var idInput = form && form.querySelector('[name="id"]');
      if (!form || !idInput) return;
      idInput.value = size.getAttribute('data-card-size');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      return;
    }

    var mobileAdd = e.target.closest('[data-card-mobile-add]');
    if (mobileAdd) {
      e.preventDefault();
      var card = mobileAdd.closest('[data-product-card]');
      var cardData = card && card.querySelector('[data-qv-data]');
      if (cardData && window.iuropQuickView) {
        window.iuropQuickView.open(cardData, { compact: true, trigger: mobileAdd });
      } else if (card) {
        window.location.href = card.querySelector('.iurop-product-card__media-link').href;
      }
      return;
    }

    var qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      var host = qv.closest('[data-product-card], [data-quick-view-host]');
      var data = host ? host.querySelector('script[data-qv-data]') : null;
      if (data && window.iuropQuickView && typeof window.iuropQuickView.open === 'function') {
        window.iuropQuickView.open(data);
      } else if (host) {
        // Sin modal disponible: navega a la PDP como fallback
        var link = host.querySelector('.iurop-product-card__media-link');
        if (link && link.href) window.location.href = link.href;
      }
    }
  });

  function init() {
    paintWishlistStates(document);
  }

  document.addEventListener('wishlist:changed', function (e) {
    paintWishlistStates(document);
    if (e.detail && typeof e.detail.active === 'boolean') showWishlistFeedback(e.detail.active);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-pinta estados en re-renders (editor de temas + inyecciones dinamicas)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('iurop:product-list:rendered', init);
})();
